<template>
  <iframe-v4-layout v-if="v4" id="v4-supplier-ads-table" :url="url" />
  <SupplierAdsTable v-else />
</template>

<script>
import IframeV4Layout from '@/components/Core/IframeV4Layout';
import SupplierAdsTable from '@/components/Supplier/Ads/SupplierAdsTable';
import { getAuthorizationToken } from '@/utils/authorization';

export default {
  components: { SupplierAdsTable, IframeV4Layout },
  computed: {
    v4() {
      return this.$store.getters['auth/feature']('v4-ads');
    },
    url() {
      const jwt = getAuthorizationToken();
      // Get filter from URL and convert to URI component to pass to iframe URL
      const filter = this.$route.query.filter;
      const sort = this.$route.query.sort;
      return (
        this.$apiUrl +
        '/supplier-v4/ads?jwt_token=' +
        jwt +
        (filter ? '&filter=' + encodeURIComponent(JSON.stringify(filter)) : '') +
        (sort ? '&sort=' + encodeURIComponent(JSON.stringify(sort)) : '')
      );
    }
  }
};
</script>
